import styled from 'styled-components';

export const ButtonTable = styled.button`
	background: none;
	border: 0;
	font-weight: bold;
	text-transform: uppercase;
`;
